module.exports = __webpack_public_path__ + "img/11.0b7462d6.jpg";